<template>
	<view class="box">
		<view class="item">
			<view class="item-label">户名</view>
			<view class="item-input">
				<input type="text" placeholder="请输入开户人姓名" />
			</view>
		</view>
		<view class="item">
			<view class="item-label">账号</view>
			<view class="item-input">
				<input type="text" placeholder="请输入银行卡号" />
			</view>
		</view>
		<view class="item">
			<view class="item-label">银行</view>
			<view class="item-input">
				<input type="text" placeholder="请输入开户行支行名称" />
			</view>
		</view>
		<view class="item" style="display: flex; align-items: center; justify-content: space-between;">
			<view class="item-label" style="color: #222222;">设为默认银行</view>
			<u-switch v-model="value" activeColor="#004096"></u-switch>
		</view>
		<view style="width: 100%; height: calc(env(safe-area-inset-bottom) + 108rpx);"></view>
		<!-- <view class="button disable">保存</view> -->
		<view class="footer">
			<view class="footer-btn1">删除银行</view>
			<view class="footer-btn2">确认</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				value: 0
			};
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 0 30rpx;
		box-sizing: border-box;
		.footer {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			position: fixed;
			bottom: calc(env(safe-area-inset-bottom) + 20rpx);
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.footer-btn1 {
				flex: 1;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				border-radius: 44rpx;
				font-weight: 500;
				font-size: 32rpx;
				color: #E4001D;
				border: 1rpx solid #E4001D;
				margin-right: 22rpx;
			}
			.footer-btn2 {
				flex: 1;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				font-weight: 500;
				font-size: 32rpx;
				color: #FFFFFF;
				background: #004096;
				border-radius: 44rpx;
			}
		}
		.disable {
			background: #EFEFEF !important;
			color: #CCCCCC !important;
		}
		.button {
			width: calc(100vw - 60rpx);
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			background: #004096;
			border-radius: 44rpx;
			font-weight: 600;
			font-size: 32rpx;
			color: #FFFFFF;
			position: fixed;
			left: 30rpx;
			bottom: calc(env(safe-area-inset-bottom) + 20rpx);
		}
		.item {
			width: 100%;
			padding: 30rpx 0;
			box-sizing: border-box;
			border-bottom: 1rpx solid #E5E5E5;
			.item-label {
				width: 100%;
				font-weight: 400;
				font-size: 28rpx;
				color: #666666;
			}
			.item-input {
				width: 100%;
				margin-top: 24rpx;
				input {
					width: 100%;
					font-weight: 400;
					font-size: 30rpx;
					color: #999999;
				}
			}
		}
	}
</style>